export const en = {
  auth: {
    signIn: "Sign in",
    signUp: "Sign up",
    welcomeTitle: "Welcome to Inchaa",
    welcomeSubtitle: "Sign in to access your projects, requests, and services.",
    emailAddress: "Email address",
    emailPlaceholder: "Enter your email",
    password: "Password",
    passwordPlaceholder: "Enter your password",
    forgotPassword: "Forgot password?",
    emailRequired: "Email is required",
    emailInvalid: "Please enter a valid email address",
    emailIsInvalid: "Email is invalid",
    passwordMinLength: "Password must be at least 6 characters",
    loginFailed: "Login failed. Please try again.",
    loginFailedCheckCredentials: "Login failed. Please check your credentials.",
    loginSuccessfulTitle: "Login Successful",
    welcomeBack: "Welcome back!",
    signInButton: "Sign in",
    newToInchaa: "New to Inchaa?",
    registerNow: "Register now",
    incorrectPassword: "Incorrect password",
    termsAndPrivacy: "<span>By logging in, you agree to Inchaa's {terms} and {privacy}.</span>",
    termsAndPrivacyText: "By logging in, you agree to Inchaa's",
    and: "and",
    copyright: "© 2025 Inchaa. All rights reserved. For support,",
    supportEmail: "support@inchaa.com",
    help: "Help",
    // Building background text
    findTrustedProfessionals: "Connect with Homeowners Looking for Professionals",
    letsBuild: "LET'S BUILD!",
    recoverPasswordTitle: "Recover your password",
    recoverPasswordSubtitle: "Enter the email address you used to sign up. We'll send you a password reset link to your email to reset your password.",
    sendEmailButton: "Send email",
    recoverPasswordHelp: "If you need further assistance",
    contactUs: "Contact Us",
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    backToSignIn: "Back to sign in",
    goToSignIn: "Go to Sign In",
    showPassword: "Show password",
    hidePassword: "Hide password",
    recoverPasswordOtpSent: "We’ve sent a password reset email to your inbox. Please check your email for further instructions.",
    recoverPasswordOtpFailed: "We couldn't send the email right now. Please try again later.",
    success: "Success",
    error: "Error",
    submitted: "Submitted",
    verificationResubmitted: "Your verification has been resubmitted for admin review.",
    registrationFailedTitle: "Registration Failed",
    failedToRegister: "Failed to complete registration. Please try again.",
    recoverPasswordOtpSubtitle: "A One-Time Password (OTP) has been sent to your registered email address.",
    recoverPasswordOtpRequired: "Please enter the complete 6-digit OTP.",
    recoverPasswordOtpInvalid: "Invalid OTP. Please try again.",
    recoverPasswordOtpVerified: "OTP verified successfully. You can now reset your password.",
    continue: "Continue",
    backToForgotPassword: "Back to Forgot Password",
    recoverPasswordEmailSentTitle: "Check your email",
    recoverPasswordEmailSentDescription: "We’ve sent a password reset link to",
    recoverPasswordEmailSentNote: "If you don’t see the email in your inbox, please check your spam folder.",
    openEmailApp: "Open email app",
    resendEmail: "Resend email",
    setNewPasswordTitle: "Set New Password",
    setNewPasswordSubtitle: "Create a new password for your account.",
    currentPasswordLabel: "Current Password",
    currentPasswordPlaceholder: "Enter current password",
    newPasswordLabel: "New Password",
    confirmPasswordLabel: "Confirm Password",
    passwordPlaceholder: "Create a password",
    confirmPasswordPlaceholder: "Confirm your password",
    passwordRequired: "Password is required",
    passwordNotMatching: "Password is not matching",
    passwordRequirementsTitle: "Password Requirements",
    passwordRequirementLength: "Must be at least 8 characters",
    passwordRequirementCase: "Include uppercase and lowercase letters",
    passwordRequirementNumber: "Include at least one number",
    passwordRequirementSpecial: "Include at least one special character",
    passwordDoesNotMeetRequirements: "Password does not meet the requirements",
    resetPasswordButton: "Reset Password",
    passwordResetSuccessTitle: "Password Reset Successful",
    passwordResetSuccessDescription: "Your password has been updated successfully. You can now log in to your Inchaa account with your new password.",
    backToSignInButton: "Back To Sign In",
    // Form text
    selectUserType: "Select User Type",
    createYourAccount: "Create Your Account",
    createAnAccount: "Create an Account",
    companyDetails: "Company Details",
    businessDetails: "Business Details",
    security: "Security",
    tellUsAboutYourCompany: "Tell us about your company",
    tellUsAboutYourBusiness: "Tell us about your business",
    tellAboutYourCompany: "Tell about your company...",
    createSecurePassword: "Create a secure password for your account",
    confirmPassword: "Confirm Password",
    createPasswordPlaceholder: "Create a password",
    confirmPasswordPlaceholder: "Confirm your password",
    approvalRequired: "Approval Required",
    approvalRequiredMessage: "Your account will be reviewed by our team. You'll receive an email notification once approved.",
    createAccount: "Create Account",
    // Verification
    verify: "Verify",
    resendOtp: "Re-send OTP",
    sendOtp: "Send OTP",
    edit: "Edit",
    otpSentToNumber: "One time password (OTP) has been sent to your mobile number",
    otpSentToEmail: "One time password (OTP) has been sent to your email",
    otpSentToNewNumber: "One time password (OTP) has been sent to your new mobile number",
    verifyAndUpdateNumber: "Verify & Update Number",
    verifyYourAccount: "Verify Your Account",
    verifyYourEmailAddress: "Verify your email address",
    verifyYourMobileNumber: "Verify your mobile number",
    verifyEmailId: "Verify Email ID",
    verifyMobileNumber: "Verify Mobile Number",
    verificationDescription: "Please complete verification to access your account",
    emailVerificationCode: "Email Verification Code",
    mobileVerificationCode: "Mobile Verification Code",
    enterSixDigitCode: "Enter 6-digit code",
    emailVerified: "Email Verified",
    mobileVerified: "Mobile Verified",
    resend: "Resend",
    sending: "Sending...",
    resendAvailableIn: "Resend available in",
    maxResendAttemptsReached: "Maximum resend attempts reached",
    pleaseEnterSixDigitEmail: "Please enter a 6-digit email verification code",
    pleaseEnterSixDigitMobile: "Please enter a 6-digit mobile verification code",
    verifyAccount: "Verify Account",
    verifying: "Verifying...",
    backToLogin: "Back to Login",
    contractor: "Contractor",
    supplier: "Supplier",
    engineer: "Engineer",
    consultant: "Consultant",
    superAdmin: "Super Admin",
    providingServices: "I provide services for construction businesses",
    suggestServices: "I can suggest services and materials",
    supplyMaterials: "I supply materials and products",
    helpForAuthorization: "I can help for authorization",
    alreadyHaveAccount: "Already have an account?",
    // Form labels and text
    profilePicture: "Profile Picture",
    recommendedSize: "Recommended size: 200x200px",
    basicInformation: "Basic Information",
    firstName: "First Name",
    firstNameRequired: "First name is required",
    firstNameLettersOnly: "First name must contain only letters",
    lastName: "Last Name",
    lastNameRequired: "Last name is required",
    lastNameLettersOnly: "Last name must contain only letters",
    enterFirstName: "Enter your first name",
    enterLastName: "Enter your last name",
    enterEmail: "Enter your email",
    phoneNumber: "Phone Number",
    mobileNumber: "Mobile Number",
    countryCodeRequired: "Country code is required",
    countryCodeSelectRequired: "Please select a country code",
    phoneNumberRequired: "Phone number is required",
    phoneDigitsOnly: "Phone number should contain only digits",
    phoneLengthBetween: "Phone number must be between {min} and {max} digits",
    phoneNumberInvalidForCountry: "Please enter a valid {country} number",
    phoneNumberInvalidFormatForCountry: "Please enter a valid {country} number format",
    invalidPhoneNumberFormat: "Invalid phone number format",
    myAccount: "My Account",
    editPhoneNumber: "Edit Phone Number",
    newPhoneNumber: "New Phone Number",
    enterNewPhoneNumber: "Enter your new phone number to update your account.",
    enterPhoneNumberPlaceholder: "Enter phone number",
    phoneVerificationInfo: "To protect your account, we'll verify the new phone number before saving changes.",
    phoneUpdatedSuccessfully: "Your phone number has been updated successfully.",
    emailOrPhoneNotAvailable: "Email or phone is not available. Please check and try again.",
    emailAlreadyRegistered: "This email is already registered. Please use a different email or sign in.",
    phoneAlreadyRegistered: "This phone number is already registered. Please use a different number or sign in.",
    unableToVerifyEmailOrPhone: "Unable to verify email/phone. Please try again.",
    creatingAccount: "Creating account…",
    confirmPasswordRequired: "Please confirm your password",
    instagramInvalidUsername: "Please enter a valid Instagram username",
    instagramNoLeadingOrTrailingPeriod: "Instagram username cannot start or end with a period",
    instagramMaxLength: "Instagram ID must be {max} characters or less",
    instagramEnterOnlyId: "Enter only Instagram ID",
    instagramAllowedChars: "Only letters, numbers, underscore (_), and period (.) are allowed",
    instagramAllowedCharsRtl: "Only letters (including Arabic), numbers, underscore (_), and period (.) are allowed",
    instagramNoConsecutivePeriods: "Cannot have consecutive periods",
    instagramUrlsNotAllowed: "URLs are not allowed. Please enter only the Instagram username",
    portfolioMaxFileSize: "File size must be less than {max}MB per file",
    fileSizeMustBeLessThan: "File size must be less than {max}MB",
    fileSizeExceedsLimit: "File size exceeds 10MB limit. Please select a smaller file.",
    invalidLicenseFileType: "Invalid file type. Please upload JPEG, PNG, WebP, or PDF files.",
    invalidFileType:"Invalid File Type.",
    pdfFilesOnly: "Please upload only PDF files.",
    letsStartWithBasicInfo: "Let's start with your basic information",
    previous: "Previous",
    back: "Back",
    next: "Next",
    // Company Details form
    companyLogo: "Company Logo",
    companyName: "Company Name",
    enterCompanyName: "Enter your company name",
    instagramIdLabel: "Instagram ID / Handle",
    instagramIdPlaceholder: "@companyname or companyname",
    companyOverview: "Company Overview",
    businessType: "Business Type",
    individual: "Individual",
    company: "Company",
    profileImage: "Profile Image",
    about: "About",
    aboutRequired: "About is required",
    tellAboutYourself: "Tell about yourself...",
    uploadProfileImage: "Upload Profile Image",
    addHere: "Add here",
    clickToAddOverview: "Click \"Add here\" to create a rich text overview about your company, experience, and services",
    shareCompanyInsights: "Share insights about your company, experience, and services.",
    streetAddress: "Street Address",
    enterStreetAddress: "Enter your street address",
    country: "Country",
    selectCountry: "Select a country",
    city: "City",
    stateProvince: "State / Province",
    selectStateProvince: "Select State / Province",
    postalCode: "Postal Code",
    enterPostalCode: "Enter your postal code",
    buildingFlatName: "Building/Flat Name",
    enterBuildingFlatName: "Building/Flat Name",
    area: "Area",
    enterArea: "Enter area",
    areaRequired: "Area is required",
    cityRequired: "City/State is required",
    countryRequired: "Country is required",
    buildingFlatNameRequired: "Building/Flat name is required",
    postalCodeRequired: "Postal code is required",
    companyNameRequired: "Company name is required",
    companyOverviewRequired: "Company overview is required",
    invalidHexColorExample: "Please enter a hex color like #FFFFFF",
    contractorTypeRequired: "Select at least one contractor type",
    consultantTypeRequired: "Select at least one consultant type",
    subServiceRequired: "Please select at least one sub-service",
    contractorTypeLabel: "Contractor Type",
    verificationUpdateTitle: "Verification Update & Resubmission",
    verificationUpdateSubtitle: "Please update the fields and resubmit for admin review.",
    rejectionSummary: "Rejection Summary",
    rejected: "Rejected",
    rejectedOn: "Rejected on",
    reason: "Reason",
    userType: "User type",
    resubmitForReview: "Resubmit for Review",
    submitting: "Submitting...",
    addServices: "Add Services",
    // Country names
    unitedArabEmirates: "United Arab Emirates",
    // UAE Emirates (States/Provinces)
    abuDhabi: "Abu Dhabi",
    dubai: "Dubai",
    sharjah: "Sharjah",
    ajman: "Ajman",
    ummAlQuwain: "Umm Al Quwain",
    rasAlKhaimah: "Ras Al Khaimah",
    fujairah: "Fujairah",
    // Business Details form
    contractorType: "Type",
    consultantType: "Type",
    engineerType: "Type",
    supplierType: "Type",
    type: "Type",
    maincontractor: "Main Contractor",
    mainContractorServices: "Main Contractor Services",
    mainContractorServicesDescription: "Main contractors will do all services.",
    subContractorServices: "Sub Contractor Services",
    subContractorServicesDescription: "Subcontractors will handle the selected services.",
    subcontractor: "Sub Contractor",
   consultantdesign:"Design - Consultant",
    designConsultant: "Design - Consultant",
    designConsultantDescription: "Provide design consultation services for construction projects",
    inspectionConsultant: "Inspection - Consultant",
    inspectionConsultantDescription: "Provide inspection and quality assurance services for construction projects",
    quantificationConsultant: "Quantification - Consultant",
    quantificationConsultantDescription: "Provide quantity surveying and cost estimation services for construction projects",
    // Role translations
    mainContractorRole: "Main Contractor",
    subContractorRole: "Sub Contractor", 
    engineerRole: "Engineer",
    contractorRole: "Contractor",
    consultantRole: "Consultant",
    servicesOffered: "Services Offered",
    chooseServicesYouOffer: "Choose the services you offer",
    subServices: "Sub Services",
    portfolioPreviousProjects: "Portfolio / Previous Projects",
    chooseFile: "Choose File",
    uploadUpTo10Files: "Upload up to 10 files (Images, Documents). Max 10MB per file.",
    submitForApproval: "Submit For Approval",
    thankYouForRegistering: "Thank You for Registering with Inchaa!",
    registrationSuccessMessage: "Your journey with Inchaa begins soon – our team will review your request within {hours} hours. You'll receive an email notification once your account is approved.",
    within48Hours: "48",
    profileSubmittedForReview: "Profile Submitted for Review",
    yourProfileUnderReview: "Your profile is now under review.",
    notifyViaEmailApproval: "We'll notify you via email once your account has been approved and you can start using our platform.",
    yearStarted: "Year Started",
    enterYearStarted: "e.g., 2017",
    licenseNumber: "License Number",
    enterLicenseNumber: "Enter license number",
    licenseExpiryDate: "License Expiry Date",
    enterExpiryDate: "Enter expiry date",
    uploadLicenseDocument: "Upload License Document",
    uploadOneFile: "Upload 1 file (JPEG, PNG, WebP, PDF). Max 10MB.",
    uploaded: "Uploaded:",
    uploadFile: "Upload File",
    uploadFiles: "Upload Files",
    uploadLogo: "Upload Logo",
    noLogoUploaded: "No logo uploaded",
    companyLogoUnsupportedType: "Unsupported file type. Please upload PNG (recommended), JPG, JPEG, SVG, or WebP files.",
    companyLogoMaxSize: "File exceeds maximum size. Please upload a file smaller than 5 MB.",
    companyLogoInvalidDimensions: "Invalid logo dimensions. Image must be between 320×320 and 400×400 pixels.",
    companyLogoInvalidRatio: "Invalid logo ratio. Image must be square (1:1 ratio).",
    companyLogoCannotRender: "File cannot be rendered. Please try a different file.",
    profileImageUnsupportedType: "Unsupported file type. Please upload PNG (recommended), JPG, JPEG, SVG, or WebP files.",
    profileImageMaxSize: "File exceeds maximum size. Please upload a file smaller than 5 MB.",
    profileImageInvalidDimensions: "Invalid profile image dimensions. Image must be between 320×320 and 400×400 pixels.",
    profileImageInvalidRatio: "Invalid profile image ratio. Image must be square (1:1 ratio).",
    profileImageCannotRender: "Profile image file cannot be rendered. Please try a different file.",
    companyLogoErrorTitle: "Company Logo Error",
    companyLogoErrorMessage: "Please fix the company logo error before submitting.",
    profileImageErrorTitle: "Profile Image Error",
    profileImageErrorMessage: "Please fix the profile image error before submitting.",
    companyOverviewMaxLength: "Company overview must be at most {max} characters.",
    aboutMaxLength: "About must be at most {max} characters.",
    backgroundColor: "Background Color",
    supportedFormatSize: "Format: Supports all image formats; PNG recommended\nSize & Ratio: 400×400 px (min 320×320 px), 1:1 (square), max 5 MB",
    selectLocation: "Select Location",
    confirmLocation: "Confirm Location",
    confirm: "Confirm",
    cancel: "Cancel",
    showingDefaultLocation: "Showing default location. Tap \"Locate Me\" to use your current position.",
    clearSearchToUseLocateMe: "Clear the search input to use Locate Me.",
    gettingCurrentLocation: "Getting your current location...",
    waitingForGPSFix: "Waiting for a precise GPS fix… Tap \"Locate Me\" if it takes too long.",
    locateMe: "Locate Me",
    locating: "Locating…",
    secureConnectionRequired: "Secure Connection Required",
    secureConnectionRequiredMessage: "This option works only on a secured connection (HTTPS). For your security, location access is available only on secure websites. Please use the map search feature to find your location, or contact your administrator to enable HTTPS for this website.",
    geolocationNotSupported: "Geolocation not supported",
    geolocationNotSupportedMessage: "Your browser does not support geolocation.",
    invalidLocation: "Invalid location",
    invalidLocationMessage: "Unable to get valid location coordinates.",
    locationError: "Location Error",
    unableToGetCurrentLocation: "Unable to get your current location.",
    locationPermissionDenied: "Location Permission Denied",
    locationAccessDeniedMessage: "Location access denied. Please enable location permissions in your browser settings and try again.",
    locationInformationUnavailable: "Location information unavailable. Please check your device location settings.",
    locationRequestTimedOut: "Location request timed out. Please ensure your device location is enabled and try again.",
    locationRequired: "Location Required",
    locationRequiredMessage: "Please choose a location on the map before confirming.",
    failedToFetchServices: "Failed to Fetch Services",
    failedToFetchServicesMessage: "Unable to load services offered. Please refresh the page or try again later.",
    invalidVerificationCode: "Invalid verification code. Please try again.",
    location: "Location",
    searchLocation: "Search location",
    addLocation: "Add Location",
    preferredLocation: "Preferred Location",
    companyAddress: "Company Address",
    seeMore: "See More",
    seeLess: "See Less",
    verified: "Verified",
    notSpecified: "Not specified",
    save: "Save",
    companyInformation: "Company Information",
    personalInformation: "Personal Information",
    companyLogo: "Company Logo",
    companyName: "Company Name",
    companyOverview: "Company Overview",
    contactPerson: "Contact Person",
    emailAddress: "Email Address",
    emailLoginInfo: "This can be used to login Inchaa application.",
    phoneNumber: "Phone Number",
    phoneEditVerificationInfo: "To edit your phone number, verification is required.",
    address: "Address",
    postalCodeLabel: "Postal Code",
    companyPortfolio: "Company Portfolio",
    portfolio: "Portfolio",
    state: "State",
    city: "City",
    loadingLocations: "Loading locations...",
    errorLoadingLocations: "Error loading locations",
    noLocationsAvailable: "No locations available",
    view: "View",
    saving: "Saving...",
    licenseInformation: "License Information",
    inReview: "In-Review",
    approved: "APPROVED",
    rejected: "REJECTED",
    pending: "PENDING",
    licenseSubmitted: "License Submitted!",
    licenseSubmittedDescription: "Our admin team will verify the information and notify you through email once approval is complete.",
    resubmit: "Resubmit",
    licenseVerificationNotApproved: "License Verification Not Approved",
    licenseRejectionDescription: "We couldn't approve your license submission due to missing or invalid information. Please review the reason below and resubmit updated details to restore access.",
    reason: "Reason",
    licenseExpiryWarning: "Your license will expire on",
    pleaseRenewBeforeExpiry: "Please renew before the expiry date.",
    updateNow: "Update Now",
    licenseExpiredContactSupport: "Your license has expired. Please contact support to renew your license.",
    licenseRejectedBannerMessage: "Your license was rejected. Please update and resubmit.",
    licenseUnderReviewBannerMessage: "Your license is under review. Please wait for approval.",
    licenseExpiringSoon: "Your license is expiring soon.",
    updateLicenseToAvoidRestriction: "Update your license to avoid temporary access restriction.",
    role: "Role:",
    licenseNumberLabel: "License Number:",
    licenseExpiry: "License Expiry:",
    yearsInBusiness: "Years in Business:",
    attachedDocument: "Attached Document",
    download: "Download",
    enterLicenseNumber: "Enter license number",
    enterBusinessStartYear: "Enter business start year (YYYY)",
    enterExpiryDate: "Enter expiry date",
    updatePassword: "Update Password",
    updating: "Updating...",
    deleteAccount: "Delete Account",
    confirmAndDelete: "Confirm & Delete",
    sendingOTP: "Sending OTP...",
    resendOTP: "Resend OTP",
    sending: "Sending...",
    verifyAndContinue: "Verify & Continue",
    verifying: "Verifying...",
    deletingAccount: "Deleting Account...",
    createAnAccount: "Create An Account",
    addYourServices: "Add Your Services",
    addMaterialsYouSupply: "Add Materials you supply",
    selectMaterialsYouSupply: "Select materials you supply",
    cantFindMaterialBrand: "Can't find a material or brand? You can request admin to add a new material or brand anytime in the account setting screen.",
    cantFindMaterialBrandTitle: "Can't find a material or brand?",
    cantFindMaterialBrandDesc: "You can request admin to add a new material or brand anytime in the account setting screen.",
    subMaterials: "Sub Materials",
    subItemsMaterials: "Sub Items (Materials)",
    subCategories: "Sub Categories",
    selectAtLeastOneMaterial: "Please select at least one material category or sub-item.",
    availableMaterials: "Available Materials",
    availableMaterialsDescription: "Select the materials you can supply. At least one item is required.",
    noMaterialsSelected: "No materials selected",
    clickToAddOrManageMaterials: "Click to add or manage materials",
    addMaterials: "Add Materials",
    manageMaterials: "Manage Materials",
    itemsSelected: "{count} item selected",
    itemsSelected_other: "{count} items selected",
    noMaterialsAvailable: "No materials available",
    engineerServicesStep: "Engineer Services",
    engineerSelectServiceTypeLabel: "Select Service Type",
    engineerSelectServiceType: "Select at least one service type",
    inspection: "Inspection",
    quantification: "Quantification",
    engineerHourlyChargesLabel: "Enter Hourly Charges (AED)",
    engineerHourlyChargesRequired: "Hourly charges are required",
    engineerHourlyChargesGreaterThanZero: "Amount must be greater than 0",
    socialInstagramUrlLabel: "Instagram URL",
    engineerHourlyChargesInvalid: "Enter a valid amount",
    engineerHourlyChargesMaxDigits: "Maximum 12 digits allowed",
    engineerSetAvailabilityLabel: "Set Your Inspection Availability",
    engineerAvailabilityDescription: "Configure your weekly schedule with 2-hour time slots from 9:00 AM to 7:00 PM",
    engineerAvailabilityRequired: "Select at least one time slot",
    engineerSelectTimeSlot: "Select Time Slot",
    engineerSlotsSelected: "slots selected",
    engineerSlot9_11: "9 AM - 11 AM",
    engineerSlot11_1: "11 AM - 1 PM",
    engineerSlot1_3: "1 PM - 3 PM",
    engineerSlot3_5: "3 PM - 5 PM",
    engineerSlot5_7: "5 PM - 7 PM",
    servicesOffering: "Services Offering",
    servicesOfferingRequired: "Select at least one service",
    viewServices: "View {{count}} Services",
    viewFullListOfServices: "View full list of services ({{count}})",
    selectServices: "Select services",
    services: "Services",
    description: "Description",
    close: "Close",
    daySunday: "Sunday",
    dayMonday: "Monday",
    dayTuesday: "Tuesday",
    dayWednesday: "Wednesday",
    dayThursday: "Thursday",
    dayFriday: "Friday",
    daySaturday: "Saturday",
    createPassword: "Create Password",
    step: "Step",
    licenseSubmittedTitle: "License Submitted!",
    licenseSubmittedDescription: "Your license details have been submitted for review. Our admin team will verify the information and notify you through email once approval is complete.",
    note: "Note",
    licenseReviewNote: "During review, your account will remain temporarily restricted.",
    accessTemporarilyRestricted: "Access Temporarily Restricted",
    licenseExpiredMessage: "Your trade license has expired. To protect customers and maintain platform compliance, your access to Inchaa has been temporarily restricted.",
    updateLicenseDetailsMessage: "Please update your license details to restore access and reappear in customer search results.",
    updateLicense: "Update License",
    updateLicenseInformation: "Update License Information",
    updateLicenseDescription: "Please provide your updated license details below. Once submitted, our admin team will review and approve your information.",
    yearStarted: "Year Started",
    licenseNumber: "License Number",
    enterLicenseNumber: "Enter license number",
    licenseExpiryDate: "License expiry date",
    enterExpiryDate: "Enter expiry date",
    uploadLicenseDocument: "Upload License Document",
    uploadFile: "Upload file",
    submitForReview: "Submit for Review",
    yearStartedRequired: "Year Started is required",
    yearStartedInvalid: "Please enter a valid year (1900 to {maxYear})",
    yearBetween: "Please enter a year between {min} and {max}",
    licenseNumberRequired: "License Number is required",
    licenseExpiryRequired: "License Expiry Date is required",
    licenseExpiryMustBeFuture: "License expiry date must be a future date",
    invalidLicenseExpiryDate: "Invalid license expiry date",
    licenseFileRequired: "License document is required",
    licenseUploadFailed: "License Upload Failed",
    licenseUploadFailedMessage: "Failed to upload license document. Please try again.",
    updateLicenseFailed: "Update Failed",
    updateLicenseFailedMessage: "Failed to update license information. Please try again.",
    pleaseEnterValidYear: "Please enter a valid year between {min} and {max}",
    pleaseEnterValidDate: "Please enter a valid date",
    yearFormatError: "Please enter a valid year in YYYY format (e.g., 2010)",
    yearRangeError: "Please enter a valid year between {min} and {max}",
    licenseExpiryFutureOnly: "License expiry date must be a future date (current and past dates are not allowed)",
    licenseDocumentRequired: "License Document is required",
    uploadFailed: "Upload failed",
    uploadDocumentsFailed: "We were not able to upload your documents. Please try again.",
    fileUploadError: "File Upload Error",
    somethingWentWrong: "Something went wrong",
    pleaseLoginAgain: "Please login again to continue.",
    goToLogin: "Go to Login",
    onlyAllowedFileTypes: "Only JPEG, PNG, WebP, and PDF files are allowed.",
    byLoggingInYouAgree: "By logging in, you agree to Inchaa's",
    and: "and",
    allRightsReserved: "© 2025 Inchaa. All rights reserved. For support,",
    submitting: "Submitting...",
    deleteAccountOtpSentToEmail: "We've sent a 6-digit verification code to your registered email ID",
    deleteAccountOtpSentToMobile: "We've sent a 6-digit verification code to your registered mobile number",
    deleteAccountOtpEnterCode: "Enter the code below to confirm you are the account owner before deletion.",
    needHelp: "Need help?",
    resendOtp: "Re-send OTP",
    deleteAccountWarningPermanent: "This action is permanent and cannot be undone.",
    deleteAccountWarningDescription: "Once your account is deleted, all your data will be permanently erased from the app, including:",
    deleteAccountWarningAccountData: "Account & Identity Data",
    deleteAccountWarningAccountDataDesc: "Your profile details, contact information, and account credentials.",
    deleteAccountWarningMediaFiles: "Media & Uploaded Files",
    deleteAccountWarningMediaFilesDesc: "Profile photos, project images, and any files you've shared.",
    deleteAccountWarningServiceHistory: "Service & Transaction History",
    deleteAccountWarningServiceHistoryDesc: "All quotations, service requests, posted ads, and related records.",
    deleteAccountWarningMessages: "Messages & Interactions",
    deleteAccountWarningMessagesDesc: "All chat history and communications with contractors, engineers, or customers.",
    deleteAccountWarningPreferences: "Saved Preferences & Customizations",
    deleteAccountWarningPreferencesDesc: "Bookmarks, saved searches, and personalized settings."
  },
  approvals: {
    userApprovalsManagement: "User Approvals Management",
    reviewAndApproveSubtitle: "Review and approve new contractor registrations with detailed service specifications.",
    totalApprovals: "Total Approvals",
    pendingApprovals: "Pending Approvals",
    allStatus: "All Status",
    pendingLabel: "Pending",
    rejectedLabel: "Rejected",
    allRoles: "All Roles",
    roles: "Roles",
    name: "Name",
    email: "Email",
    company: "Company",
    experience: "Experience",
    years: "years",
    status: "Status",
    actions: "Actions",
    role: "Role",
    noRole: "No Role",
    viewDetails: "View Details",
    rejectContractor: "Reject Contractor",
    rejectConfirmMessage: "Are you sure you want to reject {name}? Please provide a reason.",
    rejectionReason: "Rejection Reason",
    rejectionReasonPlaceholder: "Please provide a reason for rejection...",
    reject: "Reject",
    rejecting: "Rejecting...",
    errorLoadingApprovals: "Error Loading Approvals",
    failedToLoadApprovals: "Failed to load approvals. Please try again.",
    tryAgain: "Try Again",
    pleaseProvideRejectionReason: "Please provide a rejection reason.",
    failedToApproveContractor: "Failed to approve contractor.",
    failedToRejectContractor: "Failed to reject contractor.",
    approvedSuccessMessage: "{name} has been approved successfully.",
    rejectedSuccessMessage: "{name} has been rejected.",
    both: "Both",
    inspectionEngineer: "Inspection Engineer",
    quantificationEngineer: "Quantification Engineer",
    inspectionAndQuantificationEngineer: "Inspection & Quantification Engineer",
    searchPlaceholder: "Search by name, email, company...",
    searchPlaceholderMinChars: "Search by name, email, company... (min 4 chars)"
  },
  contractorsPage: {
    title: "Contractors Management",
    subtitle: "View detailed information about contractors, their quotes, performance, and activities.",
    totalContractors: "Total Contractors",
    contractorsList: "Contractors List",
    errorLoadingContractors: "Error Loading Contractors",
    failedToLoadContractors: "Failed to load contractors. Please try again."
  },
  consultantsPage: {
    title: "Consultants Management",
    subtitle: "View detailed information about consultants, their services, and activities.",
    totalConsultants: "Total Consultants",
    consultantsList: "Consultants List",
    errorLoadingConsultants: "Error Loading Consultants",
    failedToLoadConsultants: "Failed to load consultants. Please try again."
  },
  engineersPage: {
    title: "Engineers Management",
    subtitle: "View detailed information about engineers, their inspection and quantification services, performance, and activities.",
    totalEngineers: "Total Engineers",
    engineersList: "Engineers List",
    errorLoadingEngineers: "Error Loading Engineers",
    failedToLoadEngineers: "Failed to load engineers. Please try again."
  },
  customersPage: {
    title: "Customers Management",
    subtitle: "Manage customer accounts and their quote requests with comprehensive tracking and analytics.",
    totalCustomers: "Total Customers",
    customersList: "Customers List",
    errorLoadingCustomers: "Error Loading Customers",
    failedToLoadCustomers: "Failed to load customers. Please try again.",
    searchPlaceholderMinChars: "Search by name, email, phone... (min 4 chars)"
  },
  quotesBookingsPage: {
    title: "Quotations & Bookings Management",
    subtitle: "Manage all quotations from contractors with comprehensive tracking and analytics.",
    searchPlaceholderMinChars: "Search projects, customers, contractors... (min 4 chars)",
    allQuotations: "All Quotations",
    contractorQuotations: "Contractor Quotations",
    consultantQuotations: "Consultant Quotations",
    quotationsCount: "Quotations",
    contractorQuotationsDescription: "List of quotations submitted by this contractor",
    consultantQuotationsDescription: "List of quotations submitted by this consultant",
    engineerQuotations: "Engineer Quotations",
    engineerQuotationsDescription: "List of quotations for this engineer",
    contractorNoQuotationsYet: "This contractor hasn't submitted any quotations yet.",
    consultantNoQuotationsYet: "This consultant hasn't submitted any quotations yet.",
    engineerNoQuotationsYet: "This engineer has no quotations yet.",
    noQuotationsFound: "No quotations found",
    tryAdjustingSearchOrFilters: "Try adjusting your search or filters to find more quotations.",
    noQuotationsAvailableYet: "No quotations available yet.",
    loadMore: "Load more",
    loading: "Loading...",
    loadingQuotations: "Loading quotations...",
    tryAgain: "Try Again",
    noImage: "No image",
    untitledProject: "Untitled project",
    locationNotSpecified: "Location not specified",
    viewProjectDetails: "View project details",
    errorLoadingQuotations: "Error loading quotations",
    failedToLoadQuotations: "Failed to load quotations. Please try again."
  },
  superadminAds: {
    title: "Ad Posts",
    loadingAds: "Loading ads...",
    failedToLoadAds: "Failed to load ads.",
    latest: "Latest",
    oldest: "Oldest",
    adsFound: "{loaded} / {total} Ads found",
    filterByStatus: "Status",
    allStatuses: "All status",
    statusRequestChange: "Request change",
    statusActive: "Active",
    statusPending: "Pending",
    statusOnHold: "Hold"
  },
  contractorAds: {
    serviceType: "Service Type",
    location: "Location",
    searchServicesPlaceholder: "Search services...",
    quotationStatusFilter: "Quotation status",
    quotationStatusAll: "All Status",
    quotationStatusInprogress: "Inprogress",
    quotationStatusSubmitted: "Submitted",
    quotationStatusExpired: "Expired",
    quotationStatusDeclined: "Declined",
    quotationStatusCustomerRejected: "Customer rejected",
    quotationStatusCustomerAccepted: "Customer Accepted"
  },
  offersPage: {
    title: "Offers Management",
    subtitle: "Manage offers displayed on the customer mobile app home screen",
    searchPlaceholder: "Search by offer title...",
    offer: "Offer",
    offers: "Offers",
    addNewOffer: "Add New Offer",
    saveOfferOrder: "Save Offer Order",
    saving: "Saving...",
    loadingOffers: "Loading offers...",
    noOffersFound: "No offers found",
    noOffersMatchFilters: "No offers match your current filters.",
    getStartedCreateOffer: "Get started by creating a new offer.",
    order: "Order",
    created: "Created",
    updated: "Updated",
    untitled: "Untitled",
    untitledOffer: "Untitled offer",
    offerNotFound: "Offer not found",
    offerNotFoundMessage: "The offer you are trying to edit could not be found in the current list.",
    offerDeletedSuccessfully: "Offer deleted successfully",
    failedToDeleteOffer: "Failed to delete offer",
    offerUpdatedSuccessfully: "Offer updated successfully",
    offerCreatedSuccessfully: "Offer created successfully",
    create: "create",
    update: "update",
    failedToSaveOffer: "Failed to {action} offer",
    failedToUpdateOfferStatus: "Failed to update offer status",
    activated: "activated",
    deactivated: "deactivated",
    offerStatusUpdatedSuccessfully: "Offer {status} successfully",
    failedToUpdateOfferOrder: "Failed to update offer order",
    offerOrderSavedSuccessfully: "Offer order saved successfully",
    failedToSaveOfferOrder: "Failed to save offer order",
    toggleStatusTo: "Toggle status to {status}",
    moveUp: "Move up",
    moveDown: "Move down",
    moveEarlier: "Move earlier",
    moveLater: "Move later",
    edit: "Edit",
    delete: "Delete",
    deleteOffer: "Delete Offer",
    thisOffer: "this offer",
    deleteConfirm: "Are you sure you want to delete \"{title}\"? This action cannot be undone.",
    deleting: "Deleting..."
    ,
    imageEn: "Image (EN)",
    imageAr: "Image (AR)",
    dragToReorder: "Drag to reorder"
  },
  offerModal: {
    editPromotion: "Edit Promotion",
    addPromotion: "Add Promotion",
    promotionTitle: "Promotion Title",
    enterPromotionTitle: "Enter promotion title",
    promotionTitleRequired: "Promotion title is required",
    promotionBannerImageEn: "Promotion Banner Image (English)",
    promotionBannerImageAr: "Promotion Banner Image (Arabic)",
    promotionBannerImageRequiredEn: "Promotion banner image (English) is required",
    promotionBannerImageRequiredAr: "Promotion banner image (Arabic) is required",
    dragDropOrUploadImage: "Drag & drop or upload image",
    imageRequirements: "(PNG/JPG, Min 440x226 px, Max 2MB)",
    uploading: "Uploading...",
    promotionLinkEn: "Promotion Link (English)",
    promotionLinkAr: "Promotion Link (Arabic)",
    promotionLinkRequired: "Promotion link is required",
    linkType: "Link type",
    inApp: "In-App",
    web: "Web",
    inAppLinkMustStartWith: "In-App link must start with \"inchaa://\"",
    webLinkMustStartWith: "Web link must start with http:// or https://",
    activePromotionsWillAppear: "Active promotions will appear on the customer mobile app",
    promotionCreatedInactiveByDefault: "Promotion will be created as inactive by default",
    saveAndContinue: "Save & Continue",
    onlyPngAndJpgAllowed: "Only PNG and JPG images are allowed",
    fileSizeMustBeLessThan: "File size must be less than {size}"
  },
  featuredProvidersPage: {
    title: "Featured Providers",
    subtitle: "Manage featured providers and their priority order",
    searchPlaceholder: "Search providers...",
    addProvider: "Add Provider",
    addFirstProvider: "Add First Provider",
    saveProviders: "Save Providers",
    saving: "Saving...",
    saveProvidersTooltip: "Save all providers in priority order",
    selectedProvidersCount: "{count} provider(s) selected",
    removeSelected: "Remove Selected",
    refreshingProvidersList: "Refreshing providers list...",
    loadingProviders: "Loading providers...",
    errorLoadingProviders: "Error loading providers",
    noProvidersMatchSearch: "No providers found matching your search",
    noFeaturedProvidersYet: "No featured providers yet",
    remove: "Remove",
    dragToReorder: "Drag to reorder",
    pleaseSelectProvidersFirst: "Please select providers first",
    failedToRemoveProviders: "Failed to remove providers",
    failedToRemoveProvider: "Failed to remove provider",
    failedToUpdateProviderOrder: "Failed to update provider order",
    failedToUpdateProvidersList: "Failed to update providers list",
    allSelectedProvidersAlreadyAdded: "All selected providers are already added",
    failedToAddProviders: "Failed to add providers",
    pleaseAddAtLeastOneProvider: "Please add at least one provider before saving",
    providersSavedSuccessfully: "{count} provider(s) saved successfully",
    failedToSaveFeaturedProviders: "Failed to save featured providers",
    table: {
      priority: "Priority",
      providerName: "Provider Name",
      companyName: "Company Name",
      email: "Email",
      status: "Status",
      actions: "Actions"
    }
  },
  featuredProvidersModal: {
    addFeatured: "Add Featured {role}",
    searchProviders: "Search Providers",
    searchPlaceholder: "Search by name, email, or company...",
    loadingProviders: "Loading providers...",
    errorLoadingProviders: "Error loading providers",
    noProvidersAvailable: "No providers available",
    noProvidersMatchSearch: "No providers match your search criteria",
    selectAllCount: "Select All ({count})",
    showingRange: "Showing {from} to {to} of {total} providers",
    show: "Show:",
    previous: "Previous",
    next: "Next",
    pageOf: "Page {page} of {totalPages}",
    applyChanges: "Apply Changes"
  },
  licenseManagement: {
    title: "License Management",
    subtitle: "Manage license resubmissions, rejections, and expirations for service providers.",
    errorLoading: "Error Loading License Management",
    failedToLoad: "Failed to load license management data. Please try again.",
    dataRefreshedSuccessfully: "Data refreshed successfully"
  },
  serviceProviderDetails: {
    consultantApprovalDetails: "Consultant Approval Details",
    consultantDetails: "Consultant Details",
    contractorApprovalDetails: "Contractor Approval Details",
    contractorDetails: "Contractor Details",
    reviewConsultantRegistration: "Review consultant registration and approve or reject",
    viewConsultantInformation: "View consultant information and details",
    reviewContractorRegistration: "Review contractor registration and approve or reject",
    viewContractorInformation: "View contractor information and details",
    errorLoadingDetails: "Error loading service provider details",
    failedToLoadDetails: "Failed to load service provider details",
    serviceProviderNotFound: "Service Provider Not Found",
    noInformationAvailable: "No information available",
    pageNoData: "This page has no data. The information is no longer available.",
    pageNoDataAccountDeleted: "This page has no data. The account may have been deleted or the information is no longer available.",
    portfolioDocument: "Portfolio Document {number}",
    clickToView: "Click to view",
    serviceLocations: "Service Locations",
    noServiceLocationsAvailable: "No service locations available",
    servicesOfferedMainContractor: "Services Offered (Main Contractor)",
    servicesOfferedSubContractor: "Services Offered (Sub Contractor)",
    materialsList: "Materials list",
    loadingServices: "Loading services...",
    noServicesAvailable: "No services available",
    portfolio: "Portfolio",
    noPortfolioItemsAvailable: "No portfolio items available",
    licenseDocument: "License Document",
    noLicenseDocumentUploaded: "No license document uploaded",
    view: "View",
    accountStatus: "Account Status",
    processing: "Processing...",
    approveLicense: "Approve License",
    rejectLicense: "Reject License",
    licenseRejectedWithIcon: "✗ License Rejected",
    licenseExpired: "License Expired",
    approvedAndActive: "Approved & Active",
    pendingApproval: "Pending Approval",
    deactivatedDescription: "This {role}'s account is temporarily deactivated and hidden from customers. The {role} cannot receive new requests.",
    approvedDescription: "This {role} is approved and currently active. The profile is visible to customers and can receive service requests.",
    rejectedDescription: "This {role}'s account was rejected due to incomplete or invalid information. The {role} is currently not visible to customers.",
    pendingApprovalDescription: "This {role} has submitted their account and license details. Please review the information to approve or reject the account.",
    pendingApprovalInfo: "Approved {role}s will be listed for customers. Rejected accounts can resubmit updated details.",
    reactivateAccount: "Reactivate Account",
    deactivateAccount: "Deactivate Account",
    reactivateGuidance: "Reactivate the account once all issues have been resolved.",
    deactivateGuidance: "Deactivate the account if there are compliance issues or customer complaints.",
    requestResubmission: "Request Resubmission",
    requestedResubmission: "Requested Resubmission",
    resubmissionGuidance: "The {role} must update their information before approval.",
    requestFailed: "Request Failed",
    failedToRequestResubmission: "Failed to request resubmission. Please try again.",
    userIdNotFound: "User ID not found",
    approveAccount: "Approve Account",
    rejectAccount: "Reject Account",
    approveContractor: "Approve Contractor",
    rejectContractor: "Reject Contractor",
    approveConsultant: "Approve Consultant",
    rejectConsultant: "Reject Consultant",
    rejectionFailed: "Rejection Failed",
    contractorIdNotFound: "Contractor ID not found",
    rejectedSuccessMessage: "{name} has been successfully {action}.",
    pleaseProvideDeactivationReason: "Please provide a reason for deactivation.",
    accountDeactivatedMessage: "The {role} account has been deactivated successfully.",
    failedToDeactivate: "Failed to deactivate {role}. Please try again.",
    accountReactivatedMessage: "The {role} account has been reactivated successfully.",
    failedToReactivate: "Failed to reactivate {role}. Please try again.",
    deactivateAccountTitle: "Deactivate {role} Account?",
    deactivateAccountBody: "Deactivating this account will temporarily remove the {role} from customer listings and prevent them from receiving new service requests. This action can be reversed at any time by reactivating the account.",
    reasonForDeactivation: "Reason for Deactivation",
    deactivationReasonPlaceholder: "Please provide a reason for deactivating this account...",
    unableToOpenDocument: "Unable to open document. Please check your popup blocker settings.",
    documentOpened: "Document Opened",
    licenseDocumentOpened: "License document opened in new tab.",
    viewFailed: "View Failed",
    failedToOpenLicenseDocument: "Failed to open the license document. Please try again.",
    licenseDocumentUrlNotFound: "License document URL not found.",
    yearsExperience: "{years} years experience",
    imageFileAlt: "Image file",
    pdfFileAlt: "PDF file",
    documentFileAlt: "Document file",
    portfolioImageAlt: "Portfolio image",
    companyLogoAlt: "Company Logo"
    ,
    available: "Available",
    notAvailable: "Not Available",
    engineerApprovalDetails: "Engineer Approval Details",
    engineerDetails: "Engineer Details",
    reviewEngineerRegistration: "Review engineer registration and approve or reject",
    viewEngineerInformation: "View engineer information and details",
    engineerServices: "Engineer Services",
    hourlyRateAed: "Hourly Rate (AED)",
    inspectionAvailability: "Inspection Availability",
    selectTimeSlot: "Select Time Slot",
    servicesOffering: "Services Offering",
    noEngineerServices: "No services added"
  },
  quoteDetails: {
    quoteDetailsPage: "Quote Details Page",
    projectInfo: "Project Info",
    projectName: "Project Name",
    projectType: "Project Type",
    serviceType: "Service Type",
    requestedId: "Requested ID",
    quoteId: "Quote ID",
    requestedDate: "Requested Date",
    projectRequirements: "Project Requirements",
    mediaFiles: "Media Files",
    downloadAll: "Download All",
    projectLayoutPlan: "Project Layout Plan",
    layoutPlan: "Layout Plan",
    architecturalDrawings: "Architectural Drawings (2D/3D)",
    structuralDrawings: "Structural Drawings",
    materialSpecificationSheet: "Material Specification Sheet",
    propertyImages: "Property Images",
    additionalFiles: "Additional Files",
    quotationProcess: "Quotation Process",
    requestProcess: "Request Process",
    reviewRequest: "Review Request",
    reviewProjectDetails: "Review the project details and attached files. Accept or decline within {days} {daysText}.",
    shareQuotationQuestion: "Do you want to share the quotation for this request?",
    submitQuotation: "Submit Quotation",
    submitQuotationTitle: "Submit Quotation",
    interestPromptTitle: "Are you interested to take this request?",
    interestPromptSubtitle: "Interested? Confirm now and submit your quote within 72 hours.",
    interestPromptButton: "Yes, I'm Interested!",
    adPostOnHoldNotice: "This post is on hold. Interest is not available at this time.",
    enrollErrorUnavailable: "Cannot enroll. Ad not available at the moment.",
    prepareSubmitQuotation: "Prepare and submit your quotation with scope, pricing, and timeline. You must send this within {days} {daysText} of accepting the request",
    customerReviewConfirmation: "Customer Review & Confirmation",
    customerWillReview: "The customer will review your quotation. You will be notified once they confirm",
    loadingServices: "Loading services...",
    errorLoadingServices: "Error loading services",
    licenseExpiredTooltip: "Your license has expired. Please update your license to continue.",
    day: "day",
    days: "days",
    hour: "hour",
    hours: "hours",
    minute: "minute",
    minutes: "minutes",
    /** Abbrev. for acceptance countdown duration only */
    minShort: "min",
    minsShort: "mins",
    second: "second",
    seconds: "seconds",
    requestAccepted: "Request Accepted",
    requestRescheduled: "Request rescheduled",
    requestAcceptedMessage: "You accepted this request (Request ID: {requestId}). The customer has been notified of your interest.",
    interestSharedTitle: "Your interest has been shared with the customer!",
    interestSharedMessage: "You accepted this request (AD ID: {adId}). The customer has been notified of your interest.",
    requestWillExpireOn: "Your request will expire on",
    requestDeclined: "Request Declined",
    requestDeclinedMessage: "You have declined this service request. The customer will be informed that you are not proceeding with this work.",
    engineerDeclinedCustomerNotified: "You declined this request. Customer has been notified.",
    engineerRejectionReasonBadge: "Rejection Reason:",
    rescheduleRequestedTitle: "Reschedule Requested",
    rescheduleRequestedMessage:
      "Your request to reschedule the inspection has been submitted for customer approval.",
    engineerSlotDetails: "Slot details",
    engineerRequestedSlot: "Requested Slot:",
    engineerRescheduleSlot: "Reschedule Slot:",
    engineerRescheduleRequestSentTitle: "Request sent",
    engineerRescheduleRequestSentMessage: "Your reschedule request has been submitted.",
    engineerRescheduleRequestFailedTitle: "Request failed",
    engineerRescheduleRequestFailedMessage:
      "Could not submit your reschedule request. Please try again.",
    engineerRescheduleRequestSending: "Sending…",
    engineerRescheduleModalTitle: "Reschedule Request",
    engineerRescheduleModalDescription:
      "Propose a new date and time with a reason for rescheduling this inspection. Customer has 24 hours to approve.",
    engineerRescheduleModalDateLabel: "Proposed New Date & Time",
    engineerRescheduleModalReasonLabel: "Reason for Reschedule",
    engineerRescheduleModalReasonPlaceholder: "Please provide a reason for rescheduling...",
    engineerRescheduleModalDatePlaceholder: "Select date and time",
    engineerRescheduleModalSendRequest: "Send Request",
    engineerReasonForRescheduling: "Reason for rescheduling",
    engineerAwaitingAcceptanceDescription:
      "Respond by {date}. You can accept, decline, or request reschedule.",
    engineerAcceptanceMustRespondBefore:
      "You must accept or reject this request before {date}.",
    engineerAcceptanceMustRespondWithinDuration:
      "You must accept or reject this request within {duration}.",
    engineerAcceptanceDurationLessThanMinute: "less than a minute",
    engineerAcceptanceMustRespondExpired: "The response deadline has passed.",
    engineerAcceptanceMustRespondFallback:
      "You must accept or reject this request within 3 days.",
    engineerAwaitingPaymentTitle: "Awaiting Payment",
    engineerAwaitingPaymentDescription:
      "Customer must complete payment by {date}.",
    engineerPaymentDeadlineReminder:
      "Payment must be completed by {date}. The booking will be auto-cancelled if payment is not received.",
    engineerPaymentPastDeadlineBanner:
      "Payment was due by {date}. The deadline has passed — this booking may be cancelled if payment is not received.",
    engineerPaymentAutoCancelledLabel: "⚠️ Request auto-cancelled:",
    engineerPaymentAutoCancelledMessage:
      "Customer failed to complete payment before the deadline. Cancelled at: {date}",
    engineerPendingReportSubtitle: "Engineer must submit report within 3 days (72 hours)",
    engineerPendingReportDueToday: "Due today",
    engineerPendingReportDueInOneDay: "Due in 1 day",
    engineerPendingReportDueInDays: "Due in {days} days",
    engineerPendingReportOverdueDays: "Overdue by {days} days",
    engineerPendingReportInfoTitle: "Visit Completed – Submit Final Report",
    engineerPendingReportInfoBody:
      "Complete your inspection report with Q&A responses, comments, and attachments. Submit within 3 days to maintain service quality.",
    engineerPendingReportCompleteButton: "Complete Q&A & Submit Report",
    engineerPendingReportAutosavePrefix: "Auto-Save Enabled:",
    engineerPendingReportAutosaveRest: "Your answers are automatically saved as draft",
    engineerPendingReportCompleted: "Your inspection report has been submitted.",
    engineerVisitReportEmpty: "No Q&A details were included in the submitted report.",
    engineerReportSubmittedTitle: "Report Submitted",
    engineerReportSubmittedAwaitingReviewTitle: "Report Submitted – Awaiting Customer Review",
    engineerRevisedReportSubmittedTitle: "Revised Report Submitted",
    engineerViewReportHistory: "View History",
    engineerReportHistoryTitle: "View History",
    engineerReportHistoryModalTitle: "Report History",
    engineerReportHistoryModalSubtitle:
      "View all report revisions exchanged between you and the engineer. The latest report is applied to the order.",
    engineerReportHistoryDescription: "Report submissions for this inspection.",
    engineerReportHistoryLatest: "(Latest)",
    engineerReportHistoryInitial: "Initial Report",
    engineerReportHistoryDetailTitle: "Final Report",
    engineerReportHistoryDetailLead:
      "Inspection report as submitted for this quotation.",
    engineerReportHistoryOk: "OK",
    engineerReportHistoryEntrySubmitted: "Report submitted",
    engineerReportHistoryEntryInReview: "Customer issue raised (in review)",
    engineerReportHistoryEmpty: "No report milestones to show.",
    engineerIssueRaisedTitle: "Issue Raised by Customer",
    engineerIssueRaisedSubtitle: "The customer has raised an issue. Respond with a valid explanation.",
    engineerIssueTypeLabel: "Type of Issue",
    engineerIssueDescriptionLabel: "Issue Description",
    engineerIssueAttachedFilesLabel: "Attached Files",
    engineerIssueActionRequiredTitle: "Action Required",
    engineerIssueActionRequiredBody:
      "Customer is waiting for your response. Payment will remain in escrow until this issue is resolved.",
    engineerIssueResubmittedNotice:
      "You have resubmitted your report in response to this issue. The customer can review the revised submission.",
    engineerIssueResubmitReport: "Resubmit Report",
    engineerIssueViewFile: "View",
    engineerIssueStepUpcomingHint:
      "If the customer raises an issue on your report during review, details will appear here.",
    engineerIssueStepCompletedNoIssue: "No issue was raised during customer review.",
    engineerIssueStepCompletedResolved: "The customer issue was addressed and the review continued.",
    reportDetailsSectionLabel: "Report Details",
    inspectionDraftModalTitle: "Inspection report draft",
    submitInspectionReportTitle: "Submit Inspection Report",
    inspectionReportModalSubtitle: "Add ratings and a summary of your inspection findings.",
    inspectionReportDetailsPlaceholder:
      "Provide a detailed summary of your inspection findings, including any issues, risks, and recommendations.",
    inspectionQATitle: "Inspection Q&A – During Visit",
    inspectionQAProgressLabel: "Progress:",
    inspectionQAProgressAnswered: "answered",
    inspectionQATextareaPlaceholder: "Enter your detailed answer...",
    inspectionQAAttachments: "Attachments",
    inspectionQAUploadFile: "Upload file",
    inspectionQAUploadHint:
      "Images (JPEG, PNG, WebP, GIF, TIFF, BMP, HEIF/HEIC), PDF, Word (.doc, .docx) — same as signup portfolio. Max 10MB each.",
    inspectionQAInvalidFileType:
      "Invalid file type. Allowed: images (JPEG, PNG, WebP, GIF, TIFF, BMP, HEIF/HEIC), PDF, Word (.doc, .docx).",
    inspectionQASaveDraft: "Save Draft",
    inspectionQADraftBannerTitle: "Draft Mode",
    inspectionQADraftBannerBody:
      "You can prepare answers and upload attachments during your visit. All work is auto-saved. Final submission will be available after marking the visit as completed.",
    inspectionQALoadFailed: "Could not load draft report. Please try again.",
    inspectionQAEmpty: "No questions were returned for this inspection.",
    inspectionQAWordCount: "{current} / {max} words",
    inspectionQAFileTooLarge: "Each file must be at most {maxMb} MB.",
    inspectionQASaveSuccessTitle: "Draft saved",
    inspectionQASaveSuccessMessage: "Your inspection report draft was saved successfully.",
    inspectionQASaveFailed: "Could not save draft. Please try again.",
    finalReportQATitle: "Final Report Q&A Submission",
    finalReportOthersOptional: "Others (Optional)",
    finalReportOthersPlaceholder: "Please add notes if you want to add anything...",
    finalReportSubmitReport: "Submit Report",
    finalReportSubmitRequiresOneAnswer: "Enter an answer for at least one question before submitting.",
    finalReportSubmitRequiresAllAnswers:
      "Rate each category, complete the report details (max {maxWords} words), then submit. Attachments are optional.",
    finalReportSubmitSuccessTitle: "Report submitted",
    finalReportSubmitSuccessMessage: "Your inspection report was submitted successfully.",
    finalReportStatusChangeFailed: "Your draft was saved, but the status could not be updated. Please try again.",
    quotationSubmittedSuccessfully: "Your quotation was submitted successfully on",
    customerWillReviewOffer: "The customer will now review your offer",
    quotationSubmittedDescription: "Your quotation was submitted successfully on {dateTime}. The customer will now review your offer. (Quotation ID: {quotationId}, linked to Request ID: {requestId})",
    quotationAccepted: "Your quotation has been accepted by the customer. The project can now proceed.",
    quotationRejected: "Your quotation has been rejected by the customer.",
    quotationSubmittedReview: "Your quotation has been submitted and is being reviewed by the customer.",
    prepareSubmitWithinDays: "Prepare and submit your quotation within {days} {daysText} of acceptance. Include a Quotation Expiry Date",
    serviceSelectionMandatory: "Service selection is mandatory. Please select at least one service item to proceed",
    serviceListingSelected: "({selectedCount}/{totalCount} selected)",
    uploadFileVersion: "Upload a file version of your quotation (Images, PDF, Documents). Maximum size: 50 MB.",
    uploadDesignFilesDescription: "Upload design files (Images, PDF, Documents). Multiple files allowed. Total size of all files must not exceed 50 MB.",
    attachQuotationFileOptional: "Attach Quotation File (Optional)",
    attachDesignFiles: "Attach Design files",
    submittedFiles: "Submitted Files",
    attachedFile: "Attached File",
    attachedFiles: "Attached Files",
    fileGenericName: "File {index}",
    uploadFile: "Upload file",
    uploadFileVersionShort: "Upload a file version of your quotation (PDF, Word, Excel). Maximum size: 10 MB.",
    uploadFiles: "Upload files",
    uploadingFiles: "Uploading files...",
    submitting: "Submitting...",
    download: "Download",
    view: "View",
    downloadPdf: "Download PDF",
    viewFile: "View file",
    downloadDisabledClosed: "Download disabled - Quotation is closed",
    attachedDesignFiles: "Attached Design Files",
    attachedQuotationFiles: "Attached Quotation Files",
    designRequirements: "Design Requirements",
    quotationExpiryDate: "Quotation Expiry Date",
    expiryDateMaxDays: "Expiry date cannot exceed {days} days from today.",
    setValidityPeriod: "Set the validity period of this quotation. After this date, the customer will no longer be able to accept it.",
    quotationRejectedTitle: "Quotation Rejected",
    customerDidNotApprove: "The customer did not approve your quotation",
    reviewFeedback: "Please review their feedback or await another request.",
    reasonForRejection: "Reason for rejection we got from customer:",
    quotationAcceptedTitle: "Quotation Accepted",
    customerApprovedQuotation: "The customer has approved your quotation .",
    contactDetailsShared: "Your contact details have been shared with the customer. Please wait for their call to proceed with the next steps.",
    customerAcceptedQuotationTitle: "Customer Accepted the Quotation!",
    customerAcceptedQuotationDetails: "The customer accepted your quotation ({quotationId}) on {dateTime}. Your contact details have been shared with the customer. Please wait for their call to proceed with the next steps.",
    requestExpired: "Request Expired",
    noActionTaken: "No action was taken within 5 days. This request is now closed and cannot be accepted.",
    requestExpiredMessage: "No action was taken within {days} {daysText}. This request is now closed and cannot be accepted.",
    /** Engineer quotations: acceptance deadline from API `dueDate` (shown in expired card instead of a fixed day count). */
    requestExpiredMessageEngineerByDueDate:
      "No action was taken before {dateTime}. This request is now closed and cannot be accepted.",
    quotationSubmittedTitle: "Quotation Submitted",
    quotationSubmittedMessage: "Your quotation was submitted successfully on",
    submittedQuotationDetails: "Submitted Quotation Details",
    total: "TOTAL",
    notes: "Notes",
    quotationExpiredTitle: "Quotation Expired",
    quotationExpiredMessage: "The customer did not respond to your quotation within the required timeframe. This quotation has expired.",
    quotationNotSubmittedMessage: "You did not submit your quotation within the required timeframe. This project invitation has expired.",
    quotationExpiry: "Quotation Expiry",
    quotationExpiryMessage: "The customer did not respond to your quotation [DATE] within the required timeframe. This quotation has expired.",
    quotationExpiryDescription: "The customer did not respond to your quotation ({quotationId}) within the required timeframe. This quotation has expired.",
    declineInvitation: "Decline Invitation",
    declineProjectInvitation: "Decline Project Invitation",
    provideReasonForDeclining: "Please provide a reason for declining",
    provideReasonForDecliningInvitation: "Please provide a reason for declining this invitation...",
    cancel: "Cancel",
    confirmInspectionVisitCompletedTitle: "Confirm Inspection Visit Completed",
    confirmInspectionVisitCompletedSubtext: "Confirm that you have completed the on-site inspection visit.",
    confirmInspectionVisitCompletedInfo:
      "After confirming, you will have 3 days (72 hours) to submit your inspection report with all Q&A answers.",
    confirmVisitCompletedPrimaryButton: "Confirm Visit Completed",
    engineerVisitMissedTitle: "Visit Missed",
    engineerVisitMissedDescription:
      "Engineer did not complete visit within 24 hours of scheduled time",
    engineerRefundInitiatedTitle: "Refund Initiated",
    engineerRefundInitiatedDescription:
      "The customer has requested a refund. The escrow amount is being returned to the customer.",
    engineerRefundRequestedTitle: "Refund requested",
    engineerRefundRequestedDescription:
      "A refund has been requested for this inspection. You will be notified when it is processed.",
    engineerRefundedTitle: "Refunded",
    engineerRefundedDescription: "The refund for this inspection has been completed.",
    engineerMarkVisitCompletedButton: "Mark visit completed",
    engineerTimelineCompletedPaymentReleasedTitle: "Completed - Payment Released",
    engineerTimelineCompletedPaymentReleasedDescription:
      "Escrow payment has been released to you. Confirmed on {dateTime}.",
    declining: "Declining...",
    rejectRequestTitle: "Reject Request",
    rejectRequestSubtitle:
      "Please enter a reason for rejecting this request. This will be shared with the customer.",
    rejectionReasonFieldLabel: "Rejection Reason",
    reasonForRejectionFieldLabel: "Reason for Rejection",
    rejectReasonOutsideServiceArea: "Outside service area",
    rejectReasonAlreadyBooked: "Already Booked for the Time slot",
    rejectReasonInsufficientInfo: "Insufficient project information",
    rejectReasonOther: "Other",
    rejectReasonPlaceholder: "Please provide a reason for rejection.",
    confirmRejection: "Confirm Rejection",
    rejectValidationRequired: "Please select a category and enter a reason for rejection.",
    buildingName: "Building Name",
    adInfo: "Ad Info",
    adPostedOn: "Ad posted on",
    propertyName: "Property Name",
    propertyType: "Property type",
    requestId: "Request ID",
    bookedSlot: "Booked Slot",
    adId: "Ad ID",
    postedDate: "Posted Date",
    viewFileName: "View {fileName}",
    downloadFileName: "Download {fileName}",
    fileUnavailable: "The file is currently unavailable",
    unableToDownloadFile: "Unable to download file.",
    loadMore: "Load More",
    locationNotSpecified: "Location not specified",
    customerInfo: "Customer Info",
    customerName: "Customer Name",
    phoneNumber: "Phone Number",
    emailId: "Email ID",
    address: "Address",
    zipcode: "Zipcode",
    status: "Status",
    statusLabelNew: "New",
    projectInformation: "Project Information",
    requestedOn: "Requested on",
    accept: "Accept",
    decline: "Decline",
    accepting: "Accepting...",
    declining: "Declining...",
    acceptingRequest: "Accepting request...",
    decliningRequest: "Declining request...",
    sendQuotation: "Send Quotation",
    totalBuiltUpArea: "Total Built-Up Area",
    enterTotalBuiltUpAreaDescription: "Enter the total built-up area covered by this quotation and select the appropriate unit.",
    selectUnit: "Select unit",
    enterTotalBuildUpArea: "Enter total build-up area",
    services: "Services",
    serviceItems: "Service Items",
    unit: "Unit",
    qty: "Qty",
    ratePerUnit: "Rate Per Unit",
    amount: "Amount",
    currencyAed: "AED",
    addAmount: "Add amount",
    services: "Services",
    service: "Service",
    additionalServices: "Additional Services",
    addMore: "+ Add More",
    subTotal: "Sub Total",
    consultantFees: "Consultant fees",
    requestCreated: "Request Created",
    requestCreatedDescription: "A new service request has been created for this project.",
    requestInProgress: "Request In Progress",
    requestInProgressDescription: "You accepted this request (Request ID: {requestId}). The customer has been notified of your interest.",
    submittedQuotationServices: "Submitted Quotation Services",
    itemName: "Item Name",
    thirdLevelAlt: "Third level",
    reasonForDeclineOptional: "Reason for Decline (Optional)",
    reasonForDeclining: "Reason for declining:",
    placeholders: {
      enterItemName: "Enter item name...",
      serviceName: "Service name",
      addNotes: "Add notes"
    },
    validation: {
      expiryDateRequired: "Please set an expiry date to proceed",
      expiryDateFutureOnly: "Quotation expiry date must be a future date (current and past dates are not allowed)",
      totalBuiltUpAreaRequired: "Total Built-Up Area is required",
      totalBuiltUpAreaUnitRequired: "Please select a unit for Total Built-Up Area",
      consultantFeesPercentageRequired: "Consultant fees percentage is required",
      serviceNameRequired: "Service name is required",
      unitRequired: "Unit is required",
      quantityGreaterThanZero: "Quantity must be greater than 0",
      quantityMustBeOneForLS: "Quantity must be 1 for L.S unit",
      rateGreaterThanZero: "Rate must be greater than 0",
      invalidNumberSingleDecimal: "Invalid format: Only one decimal point is allowed"
    },
    toast: {
      invitationAcceptedTitle: "Invitation Accepted",
      invitationAcceptedMessage: "You have successfully accepted this project invitation. You can now proceed to submit your quote.",
      acceptFailedTitle: "Accept Failed",
      acceptFailedFallbackMessage: "Failed to accept invitation. Please try again.",
      invitationDeclinedTitle: "Invitation Declined",
      invitationDeclinedMessage: "You have successfully declined this project invitation.",
      declineFailedTitle: "Decline Failed",
      declineFailedFallbackMessage: "Failed to decline invitation. Please try again.",
      uploadFailedTitle: "Upload Failed",
      unableToUploadMessage: "Unable to upload: {fileNames}. Please check the file(s) and try again.",
      uploadErrorFallbackMessage: "An error occurred while uploading files. Please try again.",
      failedToUploadFilesMessage: "Failed to upload files: {errorMessage}",
      collectionErrorTitle: "Collection Error",
      collectionErrorMessage: "Services data is not properly loaded. Please refresh the page and try again.",
      validationErrorTitle: "Validation Error",
      invalidUnitsMessage: "Some items have invalid units. Please refresh the page and try again.",
      quotationSubmittedTitle: "Quotation Submitted",
      quotationSubmittedMessage: "Your quotation has been submitted successfully!",
      submissionFailedTitle: "Submission Failed",
      submissionFailedFallbackMessage: "Failed to submit quotation. Please try again.",
      multipleFilesTitle: "Multiple Files",
      multipleFilesMessage: "Please select only one file at a time.",
      invalidFilesTitle: "Invalid Files",
      fileSizeLimitTitle: "File Size Limit",
      duplicateFilesTitle: "Duplicate Files",
      duplicateFileTitle: "Duplicate File",
      duplicateFileAlreadyAttached: "File \"{fileName}\" is already attached.",
      multipleDuplicateFilesAlreadyAttachedList: "These files are already attached: {fileNames}",
      visitMarkedCompletedTitle: "Visit marked completed",
      visitMarkedCompletedMessage: "Your inspection visit has been marked as completed. You can now submit your report within 72 hours.",
      visitMarkedCompletedFailedTitle: "Could not update status",
      visitMarkedCompletedFailedMessage: "Failed to mark the visit as completed. Please try again.",
      visitMarkedCompletedInvalidQuotation: "Quotation could not be found. Please refresh the page and try again."
    }
  },
  serviceProvider: {
    dashboard: {
      pageTitle: "Service Provider Dashboard",
      pageTitleEngineer: "Engineer Dashboard",
      title: "Dashboard",
      subtitle: "Welcome back! Here's what's happening with your projects.",
      availability: {
        label: "Availability",
        updating: "Updating..."
      },
      toast: {
        availabilityUpdatedTitle: "Availability Updated",
        availabilityUpdatedMessage: "You are now {status} for new projects.",
        updateFailedTitle: "Update Failed",
        updateFailedMessage: "Failed to update availability. Please try again.",
        updateErrorMessage: "An error occurred while updating availability. Please try again.",
        toggleFailedTitle: "Toggle Failed",
        toggleFailedMessage: "An error occurred while toggling availability. Please try again."
      },
      metrics: {
        totalQuotations: "Total Quotations",
        submittedByRole: "{role} Submitted",
        customerAccepted: "Customer Accepted",
        customerRejected: "Customer Rejected",
        avgTurnaround: "Avg Turnaround",
        successRate: "Success Rate"
      },
      alts: {
        totalRequestedQuotes: "Total Requested Quotes",
        quotesSubmitted: "Quotes Submitted",
        customerAccepted: "Customer Accepted",
        customerRejected: "Customer Rejected"
      },
      error: {
        title: "Failed to load dashboard stats",
        message: "Please try refreshing the page or contact support if the problem persists."
      },
      recentlyRequested: "Recently Requested",
      recentlySubmitted: "Recently Submitted",
      dueLabel: "Due:",
      empty: {
        requestedQuotes: "No requested quotes available",
        recentQuotes: "No recent quotes available"
      }
    }
    ,
    invitations: {
      pageTitle: "Requests Received"
    },
    quotes: {
      pageTitle: "Submitted Quotes"
    },
    profile: {
      tabs: {
        myServices: "My Services",
        accountSettings: "Account Settings"
      },
      save: "Save",
      saving: "Saving...",
      saveServices: "Save Services",
      accountSettings: {
        validation: {
          currentPasswordRequired: "Current password is required",
          newPasswordRequired: "New password is required",
          currentPasswordIncorrect: "Current password is incorrect",
          authTokenMissing: "Authentication token not found. Please log in again.",
          networkError: "Network error. Please check your connection and try again.",
          passwordUpdateFailedFallback: "Failed to update password. Please try again.",
          emailVerificationTokenMissing: "Email verification token is missing. Please verify your email first."
        },
        toast: {
          passwordUpdateFailedTitle: "Password Update Failed",
          passwordUpdatedTitle: "Password Updated",
          passwordUpdatedMessage: "Your password has been updated successfully.",
          otpSentTitle: "OTP Sent",
          otpSendFailedTitle: "OTP Send Failed",
          emailOtpSentMessage: "A verification code has been sent to your email.",
          mobileOtpSentMessage: "A verification code has been sent to your mobile number.",
          phoneOtpSentMessage: "Verification code has been sent to your new phone number.",
          failedToSendOtpMessage: "Failed to send OTP. Please try again.",
          failedToSendOtpFallback: "Failed to send OTP",
          phoneUpdatedTitle: "Phone Number Updated",
          phoneUpdatedMessage: "Your phone number has been updated successfully.",
          licenseSubmittedTitle: "License Submitted for Review",
          licenseSubmittedMessage: "Your license has been submitted for review. You will be notified when it is approved.",
          licenseUpdateFailedTitle: "License Update Failed",
          profileUpdatedTitle: "Profile Updated Successfully!",
          profileUpdatedMessage: "Your profile has been updated successfully.",
          profileUpdateFailedTitle: "Profile Update Failed",
          profileUpdateFailedMessage: "Failed to update your profile. Please try again.",
          uploadFailedTitle: "Upload Failed"
        },
        license: {
          licenseDocumentRequired: "Please upload a license document to submit for approval"
        },
        deleteAccount: {
          verificationRequiredTitle: "Verification Required",
          verificationRequiredMessage: "Both email and mobile verification tokens are required to delete your account."
        },
        bankAccounts: {
          title: "Bank Accounts",
          subtitle: "Manage your bank accounts for payment releases",
          emptyTitle: "No bank accounts added",
          emptySubtitle: "Add your bank account to receive payment releases",
          addButton: "Add Bank Account",
          notePrefix: "Note:",
          footerNote:
            "All bank accounts require admin verification before they can be used for payouts.",
          addModalTitle: "Add Bank Account",
          importantNotice:
            "Important: All bank details will be verified by admin before payouts can be processed. Ensure all information matches your official bank documents.",
          bankAccountDetails: "Bank Account Details",
          bankName: "Bank Name",
          bankNamePlaceholder: "e.g., Emirates NBD, ADCB, Dubai Islamic Bank",
          accountHolderName: "Account Holder Name",
          accountHolderPlaceholder: "Must match company trade license name",
          accountHolderHint: "Must exactly match your company name on trade license",
          accountNumber: "Account Number",
          accountNumberPlaceholder: "Enter account number",
          accountType: "Account Type",
          currentAccount: "Current Account",
          savingsAccount: "Savings Account",
          iban: "IBAN",
          ibanPlaceholder: "AE070260001234567890123",
          ibanHint: "UAE IBAN format: 23 characters starting with AE",
          swiftBic: "SWIFT/BIC Code",
          swiftPlaceholder: "e.g., EBILAED",
          branchCode: "Branch Code",
          branchCodePlaceholder: "e.g., 026",
          branchName: "Branch Name",
          branchNamePlaceholder: "e.g., Sharjah Industrial Branch",
          primaryCheckbox: "Set as primary account for payouts",
          primaryCheckboxHint: "Primary account will be used by default for all payment releases",
          supportingDocuments: "Supporting Documents",
          supportingDocumentsIntro: "Upload at least one of the following documents for verification:",
          docBankLetter: "Bank Letter",
          docCancelledCheque: "Cancelled Cheque",
          docBankStatement: "Bank Statement",
          uploadClick: "Click to upload documents",
          uploadFormats: "PDF, JPG, or PNG (max 5MB each)",
          verificationProcessTitle: "Verification Process",
          verificationBullet1: "Submit your details and documents using this form.",
          verificationBullet2: "Our team will review your information against your official records.",
          verificationBullet3: "You will be notified once your bank account is verified or if more information is needed.",
          verificationBullet4: "Verified accounts can be used for payment releases from the platform.",
          cancel: "Cancel",
          addAccount: "Add Account",
          submitting: "Submitting…",
          labelAccountType: "Account Type",
          labelAccountNumber: "Account Number",
          labelIban: "IBAN",
          statusVerified: "Verified",
          primaryBadge: "Primary",
          statusPending: "Pending verification",
          verifiedOn: "Verified on",
          deleteAria: "Remove bank account",
          toast: {
            addedTitle: "Bank account added",
            addedMessage: "Your bank account was saved. It will appear as pending until verified by admin.",
            removedTitle: "Bank account removed",
            removedMessage: "The bank account was removed from your profile.",
            validationTitle: "Missing information",
            validationMessage: "Please fill in all required bank fields.",
            documentsRequiredTitle: "Documents required",
            documentsRequiredMessage: "Please upload at least one supporting document.",
            fileTooLargeTitle: "File too large",
            fileTooLargeMessage: "Each file must be 5MB or smaller."
          }
        }
      }
    },
    engineerPayments: {
      pageTitle: "Payments",
      title: "Payments",
      subtitle: "Manage and track all your payment transactions",
      summary: {
        totalEarnings: "Total Earnings",
        inEscrow: "In Escrow",
        pendingPayments: "Pending Payments",
        completedThisMonth: "Completed This Month"
      },
      tabs: {
        all: "All",
        completed: "Completed",
        inEscrow: "In Escrow",
        pending: "Pending"
      },
      searchPlaceholder: "Search payments...",
      serviceType: "Service Type",
      serviceTypeAll: "All types",
      export: "Export",
      columns: {
        requestId: "REQUEST ID",
        customer: "CUSTOMER",
        serviceType: "SERVICE TYPE",
        amount: "AMOUNT",
        date: "DATE",
        status: "STATUS",
        actions: "ACTIONS"
      },
      view: "View",
      amountBreakdown: "AED {rate}/hr × {hours}h",
      releasedOn: "Released: {date}",
      empty: "No payments match your filters.",
      loading: "Loading payments…",
      loadError: "Could not load payments. Please try again.",
      paginationPrev: "Previous",
      paginationNext: "Next",
      paginationPage: "Page {page} of {totalPages}",
      paginationShowing: "Showing {from}–{to} of {total}",
      statusInEscrow: "In Escrow",
      statusPending: "Pending",
      statusCompleted: "Completed",
      statusUnknown: "Unknown",
      serviceTypes: {
        inspection: "Inspection",
        quantification: "Quantification"
      },
      modal: {
        title: "Payment Details",
        paymentStatus: "Payment Status",
        amount: "Amount",
        requestId: "Request ID",
        customerName: "Customer Name",
        serviceType: "Service Type",
        paymentDate: "Payment Date",
        escrowReleaseDate: "Escrow Release Date",
        rateBreakdown: "Rate Breakdown",
        hourlyRate: "Hourly Rate",
        totalHours: "Total Hours",
        hoursUnit: "hours",
        totalAmount: "Total Amount",
        escrowInfo: "Escrow Information",
        escrowBullet1: "Payment is held in escrow until inspection completion",
        escrowBullet2: "Submit report within 3 days after inspection",
        escrowBullet3: "Funds will be released after customer confirmation",
        downloadInvoice: "Download Invoice",
        viewRequestDetails: "View Request Details",
        loadingDetails: "Loading details…",
        detailLoadError: "Could not load full payment details. Showing list data.",
        breakdown: "Breakdown"
      }
    }
  },
  status: {
    pending: "Pending",
    new: "New",
    created: "Created",
    submitted: "Submitted",
    approved: "Approved",
    licenseApproved: "License Approved",
    licenseRejected: "License Rejected",
    customerAccepted: "Customer Accepted",
    customerRejected: "Customer Rejected",
    declined: "Declined",
    closed: "Closed",
    inProgress: "In Progress",
    visitScheduled: "Visit scheduled",
    visited: "Visit completed",
    visitMissed: "Visit missed",
    reportSubmitted: "Report submitted",
    awaitingPayment: "Awaiting payment",
    paymentPendingExpired: "Payment expired",
    awaitingAcceptance: "Awaiting acceptance",
    completed: "Completed",
    expired: "Expired",
    createdExpired: "Created Expired",
    inProgressExpired: "In Progress Expired",
    submittedExpired: "Submitted Expired",
    licenseExpired: "License expired",
    cancelled: "Cancelled",
    active: "Active",
    inactive: "Inactive",
    licenseResubmitted: "License Resubmitted",
    licenseExpiredCap: "License Expired",
    underReview: "Under Review",
    onHold: "On Hold",
    archived: "Archived",
    deactivated: "Deactivated",
    disabled: "Disabled",
    unknown: "Unknown"
  },
  tableHeaders: {
    type: "Type",
    projectDetails: "Project Details",
    customer: "Customer",
    project: "Project",
    created: "Created",
    dueDate: "Due Date",
    contactShared: "Contact Shared",
    submitted: "Submitted",
    order: "Order",
    offerTitle: "Offer Title",
    image: "Image",
    lastUpdated: "Last Updated",
    createdDate: "Created Date"
  },
  menu: {
    contractors: "Contractors",
    engineers: "Engineers",
    consultants: "Consultants",
    customers: "Customers"
  },
  header: {
    openSidebar: "Open sidebar",
    notifications: "Notifications",
    loadingNotifications: "Loading notifications...",
    noNotifications: "No notifications",
    noUser: "No User",
    noRole: "No Role",
    noEmail: "No Email",
    signOut: "Sign out"
  },
  general: {
    eng: "ENG",
    arabic: "العربية",
    am: "AM",
    pm: "PM",
    viewAll: "View All",
    available: "Available",
    unavailable: "Unavailable",
    search: "Search",
    filters: "Filters",
    listView: "List view",
    gridView: "Grid view",
    fromDate: "From date",
    toDate: "To date",
    to: "to",
    clear: "Clear",
    clearAll: "Clear all",
    close: "Close",
    yes: "Yes",
    no: "No",
    unknown: "Unknown",
    allTypes: "All Types",
    viewQuotes: "View Quotes",
    pageOf: "Page {page} of {totalPages}",
    showingResults: "Showing {from} to {to} of {total} results",
    noData: "No data",
    noDataAvailable: "No data available",
    noRecordsToDisplay: "There are no records to display at the moment.",
    tryAdjustingFilters: "Try adjusting your search or filters to find more {item}.",
    tryAdjustingSearch: "Try adjusting your search or filter criteria.",
    noQuotesAvailable: "There are no quotes available at the moment.",
    noRequestsAvailable: "There are no requests available at the moment.",
    noQuotationsYet: "This customer hasn't received any quotations yet.",
    noQuantificationsYet: "You have no quantification requests yet.",
    noInspectionsYet: "You have no inspection requests yet.",
    noQuotesFound: "No quotes found",
    noRequestsFound: "No requests found",
    noQuotationsFound: "No quotations found",
    noQuantificationsFound: "No quantifications found",
    noInspectionsFound: "No inspections found",
    noProjectsFound: "No projects found",
    quotes: "quotes",
    requests: "requests",
    quotations: "quotations",
    projects: "projects",
    quantifications: "quantifications",
    inspections: "inspections"
  },
  contentManagement: {
    // Page header
    pageTitle: "Material Master List",
    pageDescription: "Manage all materials and brands available on the platform. Approved items will be available for suppliers to select and offer.",
    // Supplier requests banner
    supplierRequestsBanner: "{count} Supplier Requests – Review Required",
    reviewNewRequest: "Review New Request",
    // Tree panel
    materialList: "Material List",
    addMainCategory: "Add Main Category",
    addSubCategory: "Add Sub Category",
    addMaterial: "Add Material",
    addBrand: "Add Brand",
    addSize: "Add Size",
    // Form titles
    editMainCategory: "Edit Main Category",
    editSubCategory: "Edit Sub Category",
    editMaterial: "Edit Material",
    // Form labels
    mainCategory: "Main Category",
    subCategory: "Sub Category",
    material: "Material",
    nameEnglish: "{entity} Name (English)",
    nameArabic: "{entity} Name (Arabic)",
    enterName: "Enter {entity} Name",
    addImage: "Add Image",
    size: "Size",
    unitType: "Unit Type",
    brands: "Brands",
    brandName: "Brand Name",
    uploadImage: "Upload image",
    dragDropUpload: "Drag & drop or upload image",
    imageRequirements: "Supports all image formats; PNG recommended",
    imageDimensions: "180×180 px, 1:1 (square), max 5 MB",
    selectMainCategory: "Select main category",
    selectSubCategory: "Select sub category",
    selectCategory: "— Select —",
    // Unit types
    inch: "Inch",
    cm: "cm",
    mm: "mm",
    meter: "Meter",
    feet: "Feet",
    // Buttons
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    close: "Close",
    delete: "Delete",
    archive: "Archive",
    // Badges
    new: "New",
    review: "Review",
    // Empty state
    emptyState: "Select an item or click \"Add\" to get started",
    // Delete/Archive modal
    confirmDelete: "Confirm Delete",
    cannotDelete: "Cannot Delete",
    confirmDeleteMessage: "Are you sure you want to delete {name}? This action cannot be undone.",
    cascadeDeleteMainCategory: "This category contains subcategories and materials. Deleting it will permanently remove all related subcategories and materials. Are you sure you want to proceed?",
    cascadeDeleteSubCategory: "This subcategory contains materials. Deleting it will permanently remove all related materials. Are you sure you want to proceed?",
    hasQuotationsMessage: "This category or its materials are linked to existing quotations. You can archive it instead.",
    // Toast messages
    mainCategoryCreated: "Main category created successfully",
    mainCategoryUpdated: "Main category updated successfully",
    subCategoryCreated: "Sub category created successfully",
    subCategoryUpdated: "Sub category updated successfully",
    materialCreated: "Material created successfully",
    materialUpdated: "Material updated successfully",
    mainCategoryDeleted: "Main category deleted",
    subCategoryDeleted: "Sub category deleted",
    materialDeleted: "Material deleted",
    mainCategoryArchived: "Main category archived",
    subCategoryArchived: "Sub category archived",
    materialArchived: "Material archived",
    nameEnRequired: "Name (English) is required",
    nameArRequired: "Name (Arabic) is required",
    operationFailed: "Operation failed. Please try again.",
    deleteFailed: "Delete failed. Please try again.",
    archiveFailed: "Archive failed. Please try again.",
    invalidImageType: "Unsupported image format. Please use PNG, JPG, GIF, or WebP.",
    imageTooLarge: "Image is too large. Maximum size is 5 MB.",
    brandCreationFailed: "Failed to create brand \"{name}\". Please try again."
  },
  supplier: {
    dashboard: {
      pageTitle: "Dashboard",
      title: "Supplier Dashboard",
      subtitle: "Welcome to your supplier portal"
    },
    requests: {
      pageTitle: "Requests"
    },
    ads: {
      pageTitle: "Post Ads"
    },
    quotations: {
      pageTitle: "Quotations"
    },
    suppliers: {
      pageTitle: "Suppliers"
    },
    reports: {
      pageTitle: "Reports"
    },
    wishlist: {
      pageTitle: "Wishlist",
      empty: "No saved suppliers yet",
      emptySubtitle: "Browse suppliers and save the ones you're interested in."
    },
    support: {
      pageTitle: "Support",
      faqTitle: "Frequently Asked Questions",
      contactTitle: "Contact Us",
      submitTicket: "Submit a Ticket"
    },
    profile: {
      pageTitle: "My Account"
    },
    orders: {
      pageTitle: "Orders Placed",
      title: "Orders Placed",
      subtitle: "View all orders placed by contractors for your materials.",
      searchPlaceholder: "Search by order ID, project name, or customer...",
      moreFilters: "More Filters",
      ordered: "Ordered",
      delivery: "Delivery",
      items: "items",
      viewDetails: "View Details",
      noOrders: "No orders found",
      noOrdersSubtitle: "Orders matching your filters will appear here.",
      showing: "Showing",
      of: "of",
      results: "results",
      page: "Page",
      previous: "Previous",
      next: "Next",
      tabs: {
        all: "All Orders",
        awaiting_payment: "Awaiting Payment",
        paid_held: "Paid (Held)",
        processing: "Processing",
        out_for_delivery: "Out for Delivery",
        delivered: "Delivered",
        completed: "Completed",
        cancelled: "Cancelled"
      },
      status: {
        awaiting_payment: "Awaiting Payment",
        paid_held: "Paid (Held)",
        processing: "Processing",
        out_for_delivery: "Out for Delivery",
        dispatched: "Dispatched",
        delivered: "Delivered",
        completed: "Completed",
        cancelled: "Order Cancelled",
        accepted: "Order Accepted",
        refunded: "Refunded",
        payment_released: "Payment Released"
      },
      columns: {
        orderDetails: "Order Details",
        customer: "Customer",
        status: "Status",
        dates: "Dates",
        amount: "Amount",
        actions: "Actions"
      }
    },
    orderDetails: {
      breadcrumb: { orders: "Orders" },
      orderId: "Order ID",
      customerName: "Customer Name",
      orderDate: "Order Date",
      deliveredDate: "Delivered Date",
      orderStatus: "Order Status",
      totalAmount: "Total Amount",
      paymentMethod: "Payment Method",
      deliveredAddress: "Delivered Address",
      quickActions: "Quick Actions",
      downloadInvoice: "Download Invoice",
      timeline: { title: "Delivery Timeline" },
      escrow: { title: "Payment Held in Escrow", heldBy: "is being held by Inchaa" },
      contact: { title: "Contact Information", supplier: "Supplier", phone: "Phone", vehicle: "Vehicle Number" },
      deliveryProof: { title: "Delivery Proof", cta: "Upload Delivery Documents", hint: "Invoice, delivery note, photos" },
      materials: {
        title: "Ordered Materials",
        serviceItems: "Service Items",
        unit: "Unit",
        qty: "Qty",
        ratePerUnit: "Rate Per Unit",
        amount: "Amount (AED)",
        notes: "Notes",
        total: "Total"
      }
    }
  }
};
